// frontend/src/components/ui/LoadingSpinner.jsx
import React from 'react';
import './loading-spinner.scss';

const LoadingSpinner = ({ size = 'medium', message = 'Caricamento...' }) => {
    const sizes = {
        small: '20px',
        medium: '40px',
        large: '60px'
    };

    return (
        <div className="loading-spinner-container">
            <div 
                className="loading-spinner"
                style={{ width: sizes[size], height: sizes[size] }}
            />
            {message && <p className="loading-message">{message}</p>}
        </div>
    );
};

export default LoadingSpinner;
